import * as React from 'react'
import * as style from './style.scss'

const PlaceTitle: React.FunctionComponent = ({ children }) => <div className={style.placeTitle}>{children}</div>

export default PlaceTitle
